<template>
  <div>
    <NotificationModal v-if="notification && notificationModalState" :notification="notification" @close="modalClose"></NotificationModal>
  </div>
</template>
<script>
import NotificationModal from './NotificationModal';

export default {
  name: 'NotificationComponent',
  components: { NotificationModal },
  props: {},
  data() {
    return {
      notifications: [],
      // notification: {},
      notificationModalState: false,
    };
  },
  computed: {
    notification() {
      return this.notifications[0];
    }
  },
  watch: {
    notifications(notifications) {
      if (notifications.length) {
        this.reopenModal();
      }
    },
  },
  methods: {
    load() {
      axios.get('/ajax/notifications/unread')
        .then(response => {
          this.notifications = response.data.data;
        });
    },
    modalClose(notification) {
      this.markAsRead(notification);
      this.removeNotification(notification);
    },
    markAsRead(notification) {
      return axios.post(`ajax/notifications/${notification.id}/read`);
    },
    removeNotification(notification) {
      let index = this.notifications.findIndex((x) => {
        return x.id === notification.id;
      });
      this.notifications.splice(index, 1);
      this.reopenModal();
    },
    reopenModal() {
      this.notificationModalState = false;
      this.$nextTick(() => {
        this.notificationModalState = true;
      });
    }
  },
  mounted() {
    this.load();
  }
};
</script>
